




























import Vue, { PropType } from 'vue';
// import { BoothData } from '@/modules/exhibitor/booth';
// import { Item } from '@/modules/exhibitor/item';
// import { options } from 'mostra';
import {
  options,
  Item,
  BoothData,
} from 'mostra';

// import { itemCategories } from '@/modules/options';
// import { options } from '@/modules/options';

interface DataType {
  categoryOptions: object[];
  currentIndex: number;
  listLength: number;
  maxDisplayedItemLength: number;
  pagerLength: number;
  maxPagerLength: number;
  baseItems: Item[];
  tempItems: Item[];
  listItems: Item[];
  pagerItems: number[];
}

export default Vue.extend({
  name: 'GBoothItemForm',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    booth: {
      type: Object as PropType<BoothData>,
      required: true,
    },
    items: {
      type: Array as PropType<Item[]>,
      required: true,
    },
  },
  data(): DataType {
    return {
      categoryOptions: [{ text: '全てのカテゴリ', value: 0 }, ...options.itemCategories],
      currentIndex: 1,
      listLength: 0,
      maxDisplayedItemLength: 30,
      pagerLength: 0,
      maxPagerLength: 8,
      baseItems: [],
      tempItems: [],
      listItems: [],
      pagerItems: [],
    };
  },
  watch: {
    'booth.brandId'() {
      this.setListItems();
      this.booth.items = [];
    },
    tempItems(array: any) {
      if (array) {
        this.listLength = array.length;
        this.pagerLength = Math.ceil(array.length / this.maxDisplayedItemLength);
        this.createList(this.currentIndex);
      }
    },
    currentIndex(index: number) {
      this.createList(index);
    },
  },
  methods: {
    // async fetchItems() {
    //   try {
    //     // const uid = this.$auth.uid;
    //     this.loading = true;
    //     this.items = await item.loadsByOwner(this.$auth.cid);
    //   } catch (error: any) {
    //     console.log(error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    setListItems() {
      this.baseItems = this.items.filter((item) => item.data.brandId === this.booth.brandId);
      this.tempItems = [...this.baseItems];
      this.listItems = this.tempItems;
    },
    onCategoryChange(val: number) {
      if (!val) {
        this.tempItems = this.baseItems;
      } else {
        this.tempItems = this.baseItems.filter(
          (itemValue: Item) => val === itemValue.data.category.categoryId,
        );
      }
      this.listItems = this.tempItems;
      this.currentIndex = 1;
    },
    createList(index: number) {
      const startIndex = (index - 1) * this.maxDisplayedItemLength;
      this.listItems = [];
      for (let i = 0; i < this.maxDisplayedItemLength; i++) {
        if (!this.tempItems[startIndex + i]) break;
        this.listItems.push(this.tempItems[startIndex + i]);
      }
    },
    setPagerItems(list: number[]) {
      this.pagerItems = list;
    },
    prevPage() {
      if (this.currentIndex <= 1) return;
      this.currentIndex--;
    },
    changePage(index: number) {
      this.currentIndex = index;
    },
    nextPage() {
      if (this.currentIndex >= this.pagerLength) return;
      this.currentIndex++;
    },
  },
  mounted() {
    this.setListItems();
  },
});
